import React, { useEffect } from "react";

import { storageLocal as storage } from "../../../../../utils/StorageHandler";
import Checkbox from "../../../../shared/forms/Checkbox";
import Section from "../../../../shared/Section";
import useSnackbar from "../../../../shared/Snackbar/store";
import useCalculatorStore from "../../CalculatorPage/store";
import useCheckoutStore from "../store";
import ContactData from "./ContactData";
import DeliveryAddress from "./DeliveryAddress";
import InvoiceAddress from "./InvoiceAddress";
import MultipleUnloadingPoints from "./MultipleUnloadingPoints";
import useStepDeliveryAddress from "./store";

const StepDeliveryAddress = () => {
    const { notify } = useSnackbar();
    const [additions] = useCalculatorStore((state) => [state.additions]);

    const [
        up,
        additionalAddresses,
        useInvoiceAddress,
        increaseUnloadingPoints,
        setUseInvoiceAddress,
        storeUnloadingPointsToServer,
        addAdditionalAddress,
        setAdditionalAddresses,
    ] = useStepDeliveryAddress((state) => [
        state.up,
        state.additionalAddresses,
        state.useInvoiceAddress,
        state.increaseUnloadingPoints,
        state.setUseInvoiceAddress,
        state.storeUnloadingPointsToServer,
        state.addAdditionalAddress,
        state.setAdditionalAddresses,
    ]);

    const [checkoutData, setCheckoutData] = useCheckoutStore((state) => [
        state.checkoutData,
        state.setCheckoutData,
    ]);

    const onClickIncreaseUnloadingPoints = async () => {
        await increaseUnloadingPoints();
        await addAdditionalAddress();
        const checkoutDataResponse = await storeUnloadingPointsToServer(
            checkoutData,
            notify
        );
        setCheckoutData(checkoutDataResponse);
    };

    /**
     * Fill the additional addresses with empty data.
     */
    useEffect(() => {
        if (additionalAddresses.length < up - 1) {
            const addresses = additionalAddresses;

            for (let i = additionalAddresses.length; i < up - 1; i++) {
                addresses.push({
                    amount: 0,
                    salutation: "Herr",
                    firstname: "",
                    lastname: "",
                    phone: "",
                    street: "",
                    zipcode: storage.get("hel:zipcode"),
                    city: "",
                });
            }

            setAdditionalAddresses(addresses);
        }
    }, [up]);

    return (
        <React.Fragment>
            <Section>
                <ContactData />
            </Section>

            <Section withMargin>
                <DeliveryAddress />
            </Section>

            {up > 1 && (
                <Section withMargin>
                    <MultipleUnloadingPoints />
                </Section>
            )}

            {additions && (
                <Section withMargin>
                    <Checkbox
                        onClick={onClickIncreaseUnloadingPoints}
                        label={`zusätzlichen Haushalt beliefern`}
                    />
                </Section>
            )}

            <Section withMargin>
                <Checkbox
                    onClick={() => setUseInvoiceAddress(!useInvoiceAddress)}
                    checked={useInvoiceAddress}
                    label="Die Rechnungsadresse weicht von der Lieferadresse ab."
                />
            </Section>

            {useInvoiceAddress && (
                <Section withMargin>
                    <InvoiceAddress />
                </Section>
            )}
        </React.Fragment>
    );
};

export default StepDeliveryAddress;
